export default __webpack_public_path__ + "e797110603b2a9a3d013135c6cb86230.svg";